import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["slideoverLink"]

  open(event) {
    // Don't open if clicking a link or button inside the card
    if (event.target.closest("a, button")) return

    if (this.hasSlideoverLinkTarget) {
      this.slideoverLinkTarget.click()
    }
  }
}
